import axios from 'axios';
import { getAuthToken } from 'utils/auth';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
});
function buildConfig({ params, token, includeAuth = true, headers = {}, signal } = {}) {
  const authToken = token || getAuthToken();
  return {
    params,
    ...(signal ? { signal } : {}),
    headers: {
      'Content-Type': 'application/json',
      ...(includeAuth && authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      ...headers
    }
  };
}

function isRequestCanceled(error) {
  return error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError' || error?.name === 'AbortError';
}

function toResult(response) {
  return {
    ok: true,
    status: response.status,
    data: response.data
  };
}

function toErrorResult(error) {
  return {
    ok: false,
    status: error.response?.status || 500,
    data: error.response?.data || {}
  };
}

export async function apiGet(url, options = {}) {
  try {
    const response = await api.get(url, buildConfig(options));
    return toResult(response);
  } catch (error) {
    if (isRequestCanceled(error)) throw error;
    return toErrorResult(error);
  }
}

export async function apiPost(url, payload, options = {}) {
  try {
    const response = await api.post(url, payload, buildConfig(options));
    return toResult(response);
  } catch (error) {
    return toErrorResult(error);
  }
}

export async function apiPostForm(url, formData, options = {}) {
  try {
    const response = await api.post(
      url,
      formData,
      buildConfig({
        ...options,
        headers: {
          ...(options.headers || {}),
          'Content-Type': 'multipart/form-data'
        }
      })
    );
    return toResult(response);
  } catch (error) {
    return toErrorResult(error);
  }
}

export async function apiPut(url, payload, options = {}) {
  try {
    const response = await api.put(url, payload, buildConfig(options));
    return toResult(response);
  } catch (error) {
    return toErrorResult(error);
  }
}

export async function apiPatch(url, payload, options = {}) {
  try {
    const response = await api.patch(url, payload, buildConfig(options));
    return toResult(response);
  } catch (error) {
    return toErrorResult(error);
  }
}
